<template>
  <b-row>
    <b-col>
      <p class="text-center">You are now disconnected.</p>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions } from "vuex";
import { LOGOUT } from "@/store/actions";

import { BRow, BCol } from "bootstrap-vue";

export default {
  name: "Logout",
  components: { BRow, BCol },
  mounted() {
    this.logout();
  },
  methods: {
    ...mapActions("auth", { logout: LOGOUT }),
  },
};
</script>
